import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.16 22c-.33 0-.64-.16-.83-.44l-6.16-8.99a.997.997 0 0 1 .26-1.39c.46-.31 1.08-.19 1.39.26l5.32 7.77L20.16 2.45a1 1 0 0 1 1.38-.29 1 1 0 0 1 .29 1.38L9.99 21.55c-.18.28-.49.45-.83.45"
    />
  </svg>
);
export default SvgCheckmark;
